module.exports = __webpack_public_path__ + "static/media/Profile.1f9efdd4.svg";